import React, { useEffect, useState } from 'react'
import './galaery.css'
import axios from 'axios'
const apikey = '2HtM6wRtU2Aje9LV_HhRLrJ4YNbzRpL-6fbgbc9Lh3A'
function Galarey() {

    const [add, setAdd] = useState([])
    useEffect(() => {
        axios.get(`https://api.unsplash.com/photos/random?client_id=${apikey}&count=10`).then((res) => {
             
            setAdd(res.data)

        })
    }, [])
    return (
        <>






            <div className="header">
                Gallery
            </div>
            <div className="gallery">
                <div className="column">
                    {
                        add.map((img) => {
                            return (
                                <div className="item">
                                    <img src={img.urls.full} className="img" />

                                </div>

                            )
                        })
                    }


                    {
                        add.map((img) => {
                            return (
                                <div className="item">
                                    <img src={img.urls.full} className="img" />

                                </div>

                            )
                        })
                    }


                </div>
            </div>
        </>

    )
}

export default Galarey